(function ($) {
  jQuery(document).ready(function(){
    var signed_in_value = site.userInfoCookie.getValue('signed_in');
      if (signed_in_value == 1) {
        $('.node-25566 .menu-reference--signin .level-1').text(rb.language.my_page);
      }
  });
})(jQuery);

